import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = function ({ component: Component, admin, path }) {
    const token = JSON.parse(localStorage.getItem('scality-credentials'));
    const type = JSON.parse(localStorage.getItem('scality-usertype'));

    // SuperAdmin level is expected
    if (admin) {
        /*
        ** We disable eslint on these two lines because it considers the Route
        ** component as a component definition because its "render" props.
        */
        return (<Route path={path} render={props => (
        (token && type === 'superadmin') ? (
          <Component {...props}/>
        ) : (
          <Redirect to={{
              pathname: '/login',
          }}/>
        )
      )}/>);
    }
    return (<Route path={path} render={props => (
      (token) ? (
        <Component {...props}/>
      ) : (
        <Redirect to={{
            pathname: '/login',
        }}/>
      )
    )}/>);
};

PrivateRoute.propTypes = {
    path: PropTypes.string.isRequired,
    admin: PropTypes.bool,
    component: PropTypes.func.isRequired,
};

export default PrivateRoute;



/** WEBPACK FOOTER **
 ** ./src/utils/routing/PrivateRoute.js
 **/